import { render, staticRenderFns } from "./MyProfileForm.vue?vue&type=template&id=1b4df371&"
import script from "./MyProfileForm.vue?vue&type=script&lang=js&"
export * from "./MyProfileForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports